import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from '../../utils/API/requestMiddleware';


const employerCancellationAPI = createApi({
    reducerPath: 'employerCancellationAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        addCancellation: builder.mutation({
            query: (details) => ({
                url: '/EmployerCancellations/AddEmployerCancellations',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateCancellation: builder.mutation({
            query: (details) => ({
                url: `/EmployerCancellations/UpdateEmployerCancellations`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getCancellation: builder.mutation({
            query: (details) => ({
                url: '/EmployerCancellations/GetEmployerCancellations',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        downloadCancellationFile: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Common/DownloadFile?folderName=${details.folderName}&fileName=${details.fileName}`),
                method: 'GET',
                responseHandler: (response)=> response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const { useAddCancellationMutation, useUpdateCancellationMutation, useGetCancellationMutation,useLazyDownloadCancellationFileQuery } = employerCancellationAPI
export default employerCancellationAPI